import { ChangeDetectorRef } from '@angular/core';
import { eachDayOfInterval, isEqual, parse } from 'date-fns';
import { getDay } from 'date-fns';
import { format } from 'date-fns';
const DATE_FORMAT_MDY_SLASH = 'MM/dd/yyyy';
import _ from 'lodash';
const DATE_FORMAT_YMD = 'yyyy-MM-dd';
const DATE_FORMAT_MDY = 'MM-dd-yyyy';
import {
  ActivityDataUnitMultiValue,
  BehaviorGraphDataResponse,
  DataSheetResult,
  frequencyDatasheetGraph,
  frequencyIntervalGraph,
  latencyGraph,
  partialIntervalGraph,
  replacementDataType,
} from './insights-data.interface';

export class ManageGraphComponent {
  isGraphDataAvailable = false;
  displayNoData = false;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  graphData: any = null;
  frequencyDatasheetGraphData: frequencyDatasheetGraph | null = null;
  latencyGraphData: latencyGraph | null = null;
  replacementGraphData: replacementDataType | null = null;
  partialIntervalGraphData: partialIntervalGraph | null = null;
  frequencyIntervalGraphData: frequencyIntervalGraph | null = null;
  constructor(public cd: ChangeDetectorRef) {}

  getDataBySelectedUnit(selectedUnit: number) {
    if (selectedUnit === 1) {
      return this.frequencyDatasheetGraphData;
    } else if (selectedUnit === 2) {
      return this.latencyGraphData;
    } else if (selectedUnit === 3) {
      return this.partialIntervalGraphData;
    } else if (selectedUnit === 4) {
      return this.replacementGraphData;
    }
    return null;
  }

  manageFrequencyDataSheet(
    frequencyGraphData: frequencyDatasheetGraph | null,
    selectedUnit: number,
    viewType: number,
    showTrendLine: boolean,
    caseBehaviorId: number
  ) {
    if (
      frequencyGraphData &&
      Array.isArray(frequencyGraphData.frequency) &&
      Array.isArray(frequencyGraphData.duration) &&
      frequencyGraphData.frequency.every(
        (val: number | null) => val == null || val === 0
      ) &&
      frequencyGraphData.duration.every(
        (val: number | null) => val == null || val === 0
      )
    ) {
      this.isGraphDataAvailable = false;
      this.displayNoData = true;
      this.frequencyDatasheetGraphData = null;
      return false;
    }
    this.frequencyDatasheetGraphData =
      frequencyGraphData as frequencyDatasheetGraph;
    if (this.frequencyDatasheetGraphData) {
      this.frequencyDatasheetGraphData.showTrendLine = showTrendLine;
      this.frequencyDatasheetGraphData.caseBehaviorId = caseBehaviorId;
      const treatmentPhases = this.setTreatMentPhases(
        viewType,
        this.frequencyDatasheetGraphData?.treatmentPhases || [],
        selectedUnit
      );
      this.frequencyDatasheetGraphData!.treatmentPhases = treatmentPhases;
    }

    this.isGraphDataAvailable = true;
    this.displayNoData = false;
    return true;
  }

  manageFrequencyIntervalGraph(
    frequencyIntervalGraphData: frequencyIntervalGraph,
    showTrendLine: boolean,
    caseBehaviorId: number
  ) {
    if (
      frequencyIntervalGraphData &&
      (Object.keys(frequencyIntervalGraphData.frequencyData).length === 0 ||
        Object.values(frequencyIntervalGraphData.frequencyData).every(
          (dateFreq: Record<string, number | null>) =>
            Object.values(dateFreq).every(val => val == null || val === 0)
        ))
    ) {
      this.isGraphDataAvailable = false;
      this.displayNoData = true;
      this.frequencyIntervalGraphData = null;
      return false;
    }
    this.frequencyIntervalGraphData =
      frequencyIntervalGraphData as frequencyIntervalGraph;
    if (this.frequencyIntervalGraphData) {
      this.frequencyIntervalGraphData.showTrendLine = showTrendLine;
      this.frequencyIntervalGraphData.caseBehaviorId = caseBehaviorId;
    }

    this.isGraphDataAvailable = true;
    this.displayNoData = false;
    return true;
  }

  manageLatencyGraph(
    latencyGraphData: latencyGraph | null,
    selectedUnit: number,
    viewType: number,
    showTrendLine: boolean,
    caseBehaviorId: number
  ) {
    if (
      latencyGraphData &&
      Array.isArray(latencyGraphData.frequency) &&
      Array.isArray(latencyGraphData.averageLatency) &&
      latencyGraphData.frequency.every(
        (val: number | null) => val == null || val === 0
      ) &&
      latencyGraphData.averageLatency.every(
        (val: number | null) => val == null || val === 0
      )
    ) {
      this.isGraphDataAvailable = false;
      this.displayNoData = true;
      this.latencyGraphData = null;
      return false;
    }
    this.latencyGraphData = latencyGraphData as latencyGraph;
    if (this.latencyGraphData) {
      this.latencyGraphData.showTrendLine = showTrendLine;
      this.latencyGraphData.caseBehaviorId = caseBehaviorId;
      const treatmentPhases = this.setTreatMentPhases(
        viewType,
        this.latencyGraphData?.treatmentPhases || [],
        selectedUnit
      );
      this.latencyGraphData!.treatmentPhases = treatmentPhases;
    }
    this.isGraphDataAvailable = true;
    this.displayNoData = false;
    return true;
  }

  managePartialIntervalGraph(
    partialIntervalGraphData: partialIntervalGraph | null,
    showTrendLine: boolean,
    caseBehaviorId: number
  ) {
    if (
      partialIntervalGraphData &&
      Array.isArray(partialIntervalGraphData.interval1Percent) &&
      Array.isArray(partialIntervalGraphData.interval2Percent) &&
      Array.isArray(partialIntervalGraphData.interval3Percent) &&
      Array.isArray(partialIntervalGraphData.partialIntervalAveragePercent) &&
      partialIntervalGraphData.interval1Percent.every(
        (val: number | null) => val == null || val === 0
      ) &&
      partialIntervalGraphData.interval2Percent.every(
        (val: number | null) => val == null || val === 0
      ) &&
      partialIntervalGraphData.interval3Percent.every(
        (val: number | null) => val == null || val === 0
      ) &&
      partialIntervalGraphData.partialIntervalAveragePercent.every(
        (val: number | null) => val == null || val === 0
      )
    ) {
      this.isGraphDataAvailable = false;
      this.displayNoData = true;
      this.partialIntervalGraphData = null;
      return false;
    }
    this.partialIntervalGraphData =
      partialIntervalGraphData as partialIntervalGraph;
    if (this.partialIntervalGraphData) {
      this.partialIntervalGraphData.showTrendLine = showTrendLine;
      this.partialIntervalGraphData.caseBehaviorId = caseBehaviorId;
    }
    this.isGraphDataAvailable = true;
    this.displayNoData = false;
    return true;
  }

  manageReplacementGraph(
    replacementGraphData: replacementDataType | null,
    selectedUnit: number,
    viewType: number,
    isTrendLineEnabled: boolean,
    caseBehaviorId: number
  ) {
    if (
      replacementGraphData &&
      Array.isArray(replacementGraphData.frequency) &&
      replacementGraphData.frequency.every(
        (val: number | null) => val == null || val === 0
      )
    ) {
      this.isGraphDataAvailable = false;
      this.displayNoData = true;
      this.replacementGraphData = null;
      return false;
    }
    this.replacementGraphData = replacementGraphData as replacementDataType;
    if (this.replacementGraphData) {
      this.replacementGraphData.showTrendLine = isTrendLineEnabled;
      this.replacementGraphData.caseBehaviorId = caseBehaviorId;
      const treatmentPhases = this.setTreatMentPhases(
        viewType,
        this.replacementGraphData?.treatmentPhases || [],
        selectedUnit
      );
      this.replacementGraphData!.treatmentPhases = treatmentPhases;
    }
    this.isGraphDataAvailable = true;
    this.displayNoData = false;
    return true;
  }
  setTreatMentPhases(
    viewType: number,
    treatmentPhases: {
      treatmentPhaseName: string;
      treatmentPhaseDate: string;
    }[],
    selectedUnit: number
  ) {
    const treatmentPhase =
      treatmentPhases?.filter(
        (phase: {
          treatmentPhaseName: string;
          treatmentPhaseDate: string;
          dateLabel?: string;
        }) => {
          // Normalize incoming date string (support 'YYYY-MM-DD', 'MM/DD/YYYY', 'MM-DD-YYYY')
          const rawDate = (phase.treatmentPhaseDate || '').split('T')[0];
          const behaviorData = this.getDataBySelectedUnit(selectedUnit);
          if (!behaviorData || !rawDate) return false;

          let phaseDateObj: Date | null = null;
          if (/^\d{4}-\d{2}-\d{2}$/.test(rawDate)) {
            phaseDateObj = parse(rawDate, DATE_FORMAT_YMD, new Date());
          } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(rawDate)) {
            phaseDateObj = parse(rawDate, 'MM/dd/yyyy', new Date());
          } else if (/^\d{2}-\d{2}-\d{4}$/.test(rawDate)) {
            phaseDateObj = parse(rawDate, DATE_FORMAT_MDY, new Date());
          } else {
            // Fallback to Date constructor
            const tmp = new Date(rawDate);
            phaseDateObj = isNaN(tmp.getTime()) ? null : tmp;
          }

          if (!phaseDateObj || isNaN(phaseDateObj.getTime())) return false;

          // helper formatted value (only use MM/dd/yyyy for xLabels)
          const normalizedMDYSlash = format(
            phaseDateObj,
            DATE_FORMAT_MDY_SLASH
          );

          switch (viewType) {
            case 1: {
              // Day view: only consider 'MM/dd/yyyy' xLabels
              const matched = behaviorData?.xLabels.find(
                (label: string) => label === normalizedMDYSlash
              );
              if (matched) {
                phase.treatmentPhaseDate = matched;
                phase.dateLabel = format(phaseDateObj, DATE_FORMAT_MDY_SLASH);
                return true;
              }
              return false;
            }

            case 2: {
              // xLabels format examples: 'YYYY-MM-DD - YYYY-MM-DD' or 'MM/dd/yyyy - MM/dd/yyyy'
              const matchedLabel = behaviorData?.xLabels.find(
                (xLabel: string) => {
                  const [startStr = '', endStr = ''] = xLabel.split(' - ');
                  // Only consider MM/dd/yyyy formatted range labels for xLabels
                  const tryParse = (s: string) => {
                    const raw = s.split('T')[0].trim();
                    if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw))
                      return parse(raw, DATE_FORMAT_MDY_SLASH, new Date());
                    const tmp = new Date(raw);
                    return isNaN(tmp.getTime()) ? null : tmp;
                  };
                  const startDate = tryParse(startStr);
                  const endDate = tryParse(endStr);
                  if (!startDate || !endDate) return false;
                  return phaseDateObj! >= startDate && phaseDateObj! <= endDate;
                }
              );
              if (matchedLabel) {
                phase.treatmentPhaseDate = matchedLabel;
                phase.dateLabel = format(phaseDateObj, DATE_FORMAT_MDY_SLASH);
                return true;
              }
              return false;
            }

            case 3: {
              // xLabels format: 'MM-YYYY' (e.g., '09-2025')
              const matchedLabel = behaviorData?.xLabels.find(
                (label: string) => {
                  const [labelMonth, labelYear] = label.split('/');
                  const phaseMonth = (phaseDateObj!.getMonth() + 1)
                    .toString()
                    .padStart(2, '0');
                  const phaseYear = phaseDateObj!.getFullYear().toString();
                  return labelMonth === phaseMonth && labelYear === phaseYear;
                }
              );
              if (matchedLabel) {
                phase.treatmentPhaseDate = matchedLabel;
                phase.dateLabel = format(phaseDateObj, DATE_FORMAT_MDY_SLASH);
                return true;
              }
              return false;
            }

            case 4: {
              // xLabels format: 'Oct-Dec 2025'
              const matchedLabel = behaviorData?.xLabels.find(
                (xLabel: string) => {
                  const quarterMatch = xLabel.match(
                    /^([A-Za-z]+)-([A-Za-z]+) (\d{4})$/
                  );
                  if (!quarterMatch) return false;
                  const [, startMonthStr, endMonthStr, yearStr] = quarterMatch;
                  const months = [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec',
                  ];
                  const startMonthIdx = months.indexOf(startMonthStr);
                  const endMonthIdx = months.indexOf(endMonthStr);
                  const year = Number(yearStr);
                  // Check year matches
                  if (phaseDateObj!.getFullYear() !== year) return false;
                  const phaseMonthIdx = phaseDateObj!.getMonth(); // 0-based
                  return (
                    phaseMonthIdx >= startMonthIdx &&
                    phaseMonthIdx <= endMonthIdx
                  );
                }
              );
              if (matchedLabel) {
                phase.treatmentPhaseDate = matchedLabel;
                phase.dateLabel = format(phaseDateObj, DATE_FORMAT_MDY_SLASH);
                return true;
              }
              return false;
            }

            case 5: {
              const matchedLabel = behaviorData?.xLabels.find(
                (label: string) => phaseDateObj!.getFullYear() === Number(label)
              );
              if (matchedLabel) {
                phase.treatmentPhaseDate = matchedLabel;
                phase.dateLabel = format(phaseDateObj, DATE_FORMAT_MDY_SLASH);
                return true;
              }
              return false;
            }

            default:
              return false;
          }
        }
      ) ?? [];
    // Ensure treatmentPhaseDate is always in 'YYYY-MM-DD' format
    return treatmentPhase;
  }

  getMinMaxDate(data: DataSheetResult) {
    const dates: string[] = [
      ...(data.activityDataUnitGraphLabelResponses?.map(
        item => item.noteDate
      ) ?? []),
      ...(data.activityDataUnitValues?.map(item => item.dataDate) ?? []),
      ...(data.activityDataUnitMultiValues?.map(item => item.dataDate) ?? []),
    ];

    const dateObjects = dates.map(date => new Date(date));
    const minDate = _.min(dateObjects);
    const maxDate = _.max(dateObjects);

    return {
      minDate: minDate?.toISOString().split('T')[0],
      maxDate: maxDate?.toISOString().split('T')[0],
    };
  }
  manageFrequencyDataSheetGraphData(
    dateRange: string[],
    res: DataSheetResult,
    behaviorId = 0
  ) {
    const frequencyData: (number | null)[] = [];
    const durationData: (number | null)[] = [];
    /* eslint-disable @typescript-eslint/no-explicit-any */
    const allData: any[] = [
      ...(res?.activityDataUnitValues ?? []),
      ...(res?.activityDataUnitMultiValues ?? []),
    ];
    if (
      (!res.activityDataUnitValues ||
        res?.activityDataUnitValues?.length === 0) &&
      (!res.activityDataUnitMultiValues ||
        res?.activityDataUnitMultiValues?.length === 0)
    ) {
      this.displayNoData = true;
      return;
    }
    dateRange.forEach(date => {
      const dateData = _.filter(allData, item =>
        isEqual(
          parse(item.dataDate, 'yyyy-MM-dd', new Date()),
          parse(date, 'MM-dd-yyyy', new Date())
        )
      );
      if (dateData.length > 0) {
        if (_.some(dateData, 'blockValue')) {
          //check frequency only
          frequencyData.push(dateData[0].blockValue);
          durationData.push(null);
        } else if (_.every(dateData, { isDurationValue: false })) {
          //check frequency interval
          const freq = dateData.reduce(
            (sum, item) => sum + Number(item.unitValue),
            0
          );
          frequencyData.push(freq);
          durationData.push(null);
        } else if (_.every(dateData, { isDurationValue: true })) {
          //check duration
          const { latenctSums, freqCount } = this.getDurationAverage(dateData);
          frequencyData.push(freqCount);
          durationData.push(Math.round(latenctSums));
        }
      } else {
        frequencyData.push(null);
        durationData.push(null);
      }
    });
    const treatmentData = res.activityDataUnitGraphLabelResponses
      ? res.activityDataUnitGraphLabelResponses
          .filter(res => {
            const parsedDate = parse(res.noteDate, 'yyyy-MM-dd', new Date());
            return !isNaN(parsedDate.getTime());
          })
          .map(res => {
            res.noteDate = format(
              parse(res.noteDate, 'yyyy-MM-dd', new Date()),
              'MM-dd-yyyy'
            );
            return res;
          })
      : [];
    this.graphData = {
      dateRange,
      frequencyData,
      durationData,
      treatmentData,
      behaviorId,
    };
    this.displayNoData = false;
    this.isGraphDataAvailable = true;
    this.cd.detectChanges();
  }

  manageFrequencyIntervalGraphData(
    dateRange: string[],
    res: DataSheetResult,
    behaviorId = 0
  ) {
    if (
      (!res.activityDataUnitValues ||
        res?.activityDataUnitValues?.length === 0) &&
      (!res.activityDataUnitMultiValues ||
        res?.activityDataUnitMultiValues?.length === 0)
    ) {
      this.displayNoData = true;
      return;
    }

    // Add `frequency` field based on `isDurationValue`
    const processedData = res?.activityDataUnitMultiValues.map(
      (record: ActivityDataUnitMultiValue) => ({
        ...record,
        frequency: record.isDurationValue
          ? record.unitValue
              .split(',')
              .filter((value: string) => value.trim() !== '').length
          : parseInt(record.unitValue, 10), // Convert string to number
      })
    );

    // Group by startDataTime - endDataTime first
    const groupedByTime = _.groupBy(
      processedData,
      record => `${record.startDataTime} - ${record.endDataTime}`
    );

    // Then group each time range by dataDate and return only `frequency`
    const frequencyData = _.mapValues(groupedByTime, records => {
      const groupedByDate = _.groupBy(records, 'dataDate');
      const convertDateFormat = (date: string) =>
        format(parse(date, 'yyyy-MM-dd', new Date()), 'MM-dd-yyyy');
      const finalDates = _.mapKeys(groupedByDate, (_, key) =>
        convertDateFormat(key)
      );
      // Ensure all dates from dateArray exist, if missing, set as null
      return dateRange.reduce<Record<string, number | null>>((acc, date) => {
        acc[date] = finalDates[date]?.[0]?.frequency ?? null;
        return acc;
      }, {});
    });

    this.graphData = {
      dateRange,
      frequencyData,
      behaviorId,
    };

    this.displayNoData = false;
    this.isGraphDataAvailable = true;
    this.cd.detectChanges();
  }

  manageInternalFrequencyGraphData(
    dateRange: string[],
    res: DataSheetResult,
    behaviorId = 0
  ) {
    const interval1Data: (number | null)[] = [];
    const interval2Data: (number | null)[] = [];
    const interval3Data: (number | null)[] = [];
    const averagePartialValues: (number | null)[] = [];
    const data = _.filter(res?.activityDataUnitMultiValues, {
      isIntervalFrequency: true,
    });

    if (data.length <= 0) {
      this.displayNoData = true;
      return;
    }
    dateRange.forEach(date => {
      const exists = _.find(data, item =>
        isEqual(
          parse(item.dataDate, 'yyyy-MM-dd', new Date()),
          parse(date, 'MM-dd-yyyy', new Date())
        )
      );
      if (exists) {
        const unitValues = exists.unitValue.split(',');
        const unitValueArray: string[] = _.filter(
          unitValues,
          val => val.trim() !== ''
        );
        averagePartialValues.push(
          Math.round(
            _.sum(_.map(unitValueArray, num => Number(num))) /
              unitValueArray.length
          ) * 10
        );
        interval1Data.push(unitValues[0] ? Number(unitValues[0]) * 10 : null);
        interval2Data.push(unitValues[1] ? Number(unitValues[1]) * 10 : null);
        interval3Data.push(unitValues[2] ? Number(unitValues[2]) * 10 : null);
      } else {
        averagePartialValues.push(null);
        interval1Data.push(null);
        interval2Data.push(null);
        interval3Data.push(null);
      }
    });

    this.graphData = {
      dateRange,
      interval1Data,
      interval2Data,
      interval3Data,
      averagePartialValues,
      behaviorId,
    };
    this.displayNoData = false;
    this.isGraphDataAvailable = true;
    this.cd.detectChanges();
  }

  manageLatencyGraphData(
    dateRange: string[],
    res: DataSheetResult,
    behaviorId = 0
  ) {
    const averageLatencyData: (number | null)[] = [];
    const frequencyData: (number | null)[] = [];
    const data = _.filter(res?.activityDataUnitMultiValues, {
      isDurationValue: true,
    });

    if (data.length <= 0) {
      this.displayNoData = true;
      return;
    }

    dateRange.forEach(date => {
      const dateData: ActivityDataUnitMultiValue[] = _.filter(data, item =>
        isEqual(
          parse(item.dataDate, 'yyyy-MM-dd', new Date()),
          parse(date, 'MM-dd-yyyy', new Date())
        )
      );
      if (dateData.length > 0) {
        const { latenctSums, freqCount } = this.getDurationAverage(dateData);
        frequencyData.push(freqCount);
        averageLatencyData.push(Math.round(latenctSums / freqCount));
      } else {
        averageLatencyData.push(null);
        frequencyData.push(null);
      }
    });
    const treatmentData = res.activityDataUnitGraphLabelResponses
      ? res.activityDataUnitGraphLabelResponses
          .filter(res => {
            const parsedDate = parse(res.noteDate, 'yyyy-MM-dd', new Date());
            return !isNaN(parsedDate.getTime());
          })
          .map(res => {
            res.noteDate = format(
              parse(res.noteDate, 'yyyy-MM-dd', new Date()),
              'MM-dd-yyyy'
            );
            return res;
          })
      : [];

    this.graphData = {
      dateRange,
      averageLatencyData,
      frequencyData,
      treatmentData,
      behaviorId,
    };
    this.displayNoData = false;
    this.isGraphDataAvailable = true;
    this.cd.detectChanges();
  }

  getDurationAverage(arrays: ActivityDataUnitMultiValue[]) {
    let freqCount = 0;
    const sums = _.map(arrays, arr => {
      const nonEmptyUnitValue: number[] = arr.unitValue
        .split(',') // Split by comma
        .map(_.trim) // Trim spaces
        .filter(Boolean) // Remove empty values
        .map(_.toNumber); // Convert to numbers

      freqCount = freqCount + nonEmptyUnitValue.length;
      return _.sum(nonEmptyUnitValue); // Sum the values
    });

    return { latenctSums: _.sum(sums), freqCount };
  }

  manageReplacementGraphData(
    dateRange: string[],
    res: DataSheetResult,
    behaviorId = 0
  ) {
    const totalFrequency: (number | null)[] = [];

    if (
      (!res.activityDataUnitValues ||
        res?.activityDataUnitValues?.length === 0) &&
      (!res.activityDataUnitMultiValues ||
        res?.activityDataUnitMultiValues?.length === 0)
    ) {
      this.displayNoData = true;
      return;
    }
    /* eslint-disable @typescript-eslint/no-explicit-any */
    const allData: any[] = [
      ...(res?.activityDataUnitValues ?? []),
      ...(res?.activityDataUnitMultiValues ?? []),
    ];
    dateRange.forEach(date => {
      const dateData = _.filter(allData, item =>
        isEqual(
          parse(item.dataDate, 'yyyy-MM-dd', new Date()),
          parse(date, 'MM-dd-yyyy', new Date())
        )
      );
      if (dateData.length > 0) {
        const freq = dateData.reduce(
          (sum, item) =>
            sum + Number(item.blockValue ? item.blockValue : item.unitValue),
          0
        );
        totalFrequency.push(freq);
      } else {
        totalFrequency.push(null);
      }
    });
    const treatmentData = res.activityDataUnitGraphLabelResponses
      ? res.activityDataUnitGraphLabelResponses
          .filter(res => {
            const parsedDate = parse(res.noteDate, 'yyyy-MM-dd', new Date());
            return !isNaN(parsedDate.getTime());
          })
          .map(res => {
            res.noteDate = format(
              parse(res.noteDate, 'yyyy-MM-dd', new Date()),
              'MM-dd-yyyy'
            );
            return res;
          })
      : [];
    this.graphData = {
      dateRange,
      totalFrequency,
      treatmentData,
      behaviorId,
    };
    this.displayNoData = false;
    this.isGraphDataAvailable = true;
    this.cd.detectChanges();
  }

  getDateRange(startDate: Date, endDate: Date) {
    return eachDayOfInterval({
      start: startDate,
      end: endDate,
    })
      .filter(date => getDay(date) !== 0 && getDay(date) !== 6) // Exclude weekends
      .map(date => format(date, 'MM-dd-yyyy')); // Format as needed
  }

  protected async processBehaviorGraphData(
    data: BehaviorGraphDataResponse,
    selectedUnit: number,
    graphType: number,
    viewTypeValue: number | null,
    isTrendLineValue: boolean,
    onSuccess?: (
      unit: number,
      graphData:
        | frequencyDatasheetGraph
        | latencyGraph
        | replacementDataType
        | partialIntervalGraph
        | frequencyIntervalGraph,
      showInterval?: boolean
    ) => Promise<void> | void
  ): Promise<boolean> {
    try {
      switch (selectedUnit) {
        case 1: {
          switch (graphType) {
            case 1: {
              const frequencyGraphData =
                data.frequencyDuration as frequencyDatasheetGraph;
              const viewType = viewTypeValue || 1;
              const isAvailable = this.manageFrequencyDataSheet(
                frequencyGraphData,
                selectedUnit,
                viewType,
                isTrendLineValue,
                data.caseBehaviorId
              );
              if (isAvailable && this.frequencyDatasheetGraphData) {
                if (onSuccess) {
                  await onSuccess(
                    selectedUnit,
                    this.frequencyDatasheetGraphData
                  );
                }
                return true;
              }
              return false;
            }
            case 2: {
              const frequencyIntervalGraphData =
                data.frequencyInterval as frequencyIntervalGraph;
              const isAvailable = this.manageFrequencyIntervalGraph(
                frequencyIntervalGraphData,
                isTrendLineValue,
                data.caseBehaviorId
              );
              if (isAvailable && this.frequencyIntervalGraphData) {
                if (onSuccess) {
                  await onSuccess(
                    selectedUnit,
                    this.frequencyIntervalGraphData,
                    true
                  );
                }
                return true;
              }
              return false;
            }
          }
          break;
        }

        case 2: {
          const latencyGraphData = data.latency as latencyGraph;
          const viewType = viewTypeValue || 1;
          const isAvailable = this.manageLatencyGraph(
            latencyGraphData,
            selectedUnit,
            viewType,
            isTrendLineValue,
            data.caseBehaviorId
          );
          if (isAvailable && this.latencyGraphData) {
            if (onSuccess) {
              await onSuccess(selectedUnit, this.latencyGraphData);
            }
            return true;
          }
          return false;
        }

        case 3: {
          const partialIntervalGraphData =
            data.partialInterval as partialIntervalGraph;
          const isAvailable = this.managePartialIntervalGraph(
            partialIntervalGraphData,
            isTrendLineValue,
            data.caseBehaviorId
          );
          if (isAvailable && this.partialIntervalGraphData) {
            this.partialIntervalGraphData.caseBehaviorId = data.caseBehaviorId;
            if (onSuccess) {
              await onSuccess(selectedUnit, this.partialIntervalGraphData);
            }
            return true;
          }
          return false;
        }

        case 4: {
          const replacementGraphData =
            data.replacementBehavior as replacementDataType;
          const viewType = viewTypeValue || 1;
          const isAvailable = this.manageReplacementGraph(
            replacementGraphData,
            selectedUnit,
            viewType,
            isTrendLineValue,
            data.caseBehaviorId
          );
          if (isAvailable && this.replacementGraphData) {
            if (onSuccess) {
              await onSuccess(selectedUnit, this.replacementGraphData);
            }
            return true;
          }
          return false;
        }
      }
      return false;
    } catch (error) {
      console.error('Error in processBehaviorGraphData:', error);
      throw error;
    }
  }
}
